module["exports"] = [
  "Aargau",
  "Appenzell Ausserrhoden",
  "Appenzell Innerrhoden",
  "Basel-Land",
  "Basel-Stadt",
  "Bern",
  "Freiburg",
  "Genf",
  "Glarus",
  "Graubünden",
  "Jura",
  "Luzern",
  "Neuenburg",
  "Nidwalden",
  "Obwalden",
  "St. Gallen",
  "Schaffhausen",
  "Schwyz",
  "Solothurn",
  "Tessin",
  "Thurgau",
  "Uri",
  "Waadt",
  "Wallis",
  "Zug",
  "Zürich"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/de_CH/address/state.js
// module id = 2525
// module chunks = 1610